<div class="kt-subheader kt-grid__item">
    <div class="kt-subheader__main">
        <h3 class="kt-subheader__title cursor-pointer">
            <span translation="Axilla.BasketOverview" source="Axilla"></span>
            <ng-container *ngIf="checkOnlineHelperFeature()">
                <helper bookmark="basket"></helper>
            </ng-container>
        </h3>
    </div>
    <div class="kt-subheader__toolbar">
        <div class="kt-subheader__wrapper d-flex align-items-center">
            <button *ngIf="isAllowGoBackToProducts"
                    class="btn btn-primary"
                    (click)="backToProducts()">
                <i class="fas fa-arrow-left"></i>
                {{ "BackToProducts" | localize }}
            </button>

            <button *ngIf="isAllowGoBackToPromotion"
                    class="btn btn-primary"
                    (click)="backToPromotion()">
                <i class="fas fa-arrow-left"></i>
                {{ "BackToPromotion" | localize }}
            </button>

            <button class="btn btn-primary"
                    [disabled]="isDisabled"
                    (click)="clearOrder()">
                <i class="fas fa-trash-alt"></i>
                <span translation="Axilla.BasketOverview.Clear" source="Axilla"></span>
            </button>

            <button class="btn btn-primary"
                    [disabled]="isConfirmDisabled"
                    (click)="confirmOrder()">

                <ng-container *ngIf="isGuided && isCheckOrderState; else notGuided">
                    {{ "SelectSupplier" | localize }}
                </ng-container>
                <ng-template #notGuided>
                    <span translation="Axilla.BasketOverview.ConfirmOrder" source="Axilla"></span>
                </ng-template>

            </button>

            <ng-container *ngIf="checkOnlineHelperFeature() && !isOuBlocked">
                <helper bookmark="confirmBasket"></helper>
            </ng-container>

            <!--<button class="btn btn-primary"
            [disabled]="isDisabled"
            (click)="submit()">
        <span translation="Axilla.BasketOverview.Submit" source="Axilla"></span>
    </button>-->
        </div>
    </div>
</div>
<div id="pa-form">
</div>

<div class="kt-content distribution">
    <div class="kt-portlet">
        <div class="kt-portlet__body">
            <div class="custom-card-body tab-lines">

                <ng-container *ngIf="package && 'Pages.App.Webshop.View.ShowPalletsInfo' | permission">
                    <app-pallets></app-pallets>
                </ng-container>

                <div class="row">
                    <div class="col-lg-12">

                        <ng-container *ngIf="isVerifyPromotions">
                            <ng-container *ngIf="totalItemAmount && orderAmount && promotionValue && promotionValueInEuro">
                                <div class="d-flex align-items-center p-justify-center gap-2 promotion-limits mb-4" [ngClass]="{'exceeded': isPromotionLimitExceeded}">
                                    <span>Current Order:</span>
                                    <span>
                                        {{orderAmount | currency:getCurrency():'symbol-narrow':'.2-2'}}
                                    </span>
                                    <ng-container *ngIf="promotionValue > 0">
                                        <span>
                                            x
                                        </span>
                                        <span>
                                            {{promotionValue}} %
                                        </span>
                                    </ng-container>
                                    <span>
                                        =>
                                    </span>
                                    <span>
                                        {{promotionValueInEuro | currency:getCurrency():'symbol-narrow':'.2-2'}}
                                    </span>
                                    <span>
                                        <>
                                    </span>
                                    <span>
                                        {{totalItemAmount | currency:getCurrency():'symbol-narrow':'.2-2'}}
                                    </span>
                                </div>
                            </ng-container>

                        </ng-container>



                        <div class="products">
                            <p-table #dataTable
                                     styleClass="p-datatable-striped"
                                     [lazy]="true"
                                     (onLazyLoad)="getBasket($event)"
                                     [value]="primengTableHelper.records"
                                     rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                                     responsiveLayout="stack"
                                     [breakpoint]="'800px'"
                                     [responsive]="primengTableHelper.isResponsive"
                                     [resizableColumns]="primengTableHelper.resizableColumns">
<!--                                <ng-template pTemplate="header">-->
<!--                                    <tr>-->
<!--                                        <th style="width: 10em">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.Picture" source="Axilla">-->
<!--                                            </span>-->
<!--                                        </th>-->
<!--                                        <th pSortableColumn="code" style="width: 10em">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.Code" source="Axilla">-->
<!--                                            </span>-->
<!--                                            <p-sortIcon field="code"></p-sortIcon>-->
<!--                                        </th>-->
<!--                                        <th pSortableColumn="title">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.Title" source="Axilla">-->
<!--                                            </span>-->
<!--                                            <p-sortIcon field="title"></p-sortIcon>-->
<!--                                        </th>-->

<!--                                        <th pSortableColumn="description">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.Description" source="Axilla">-->
<!--                                            </span>-->
<!--                                            <p-sortIcon field="description"></p-sortIcon>-->
<!--                                        </th>-->
<!--                                        <th style="width: 5em; text-align: right">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.ItemAmount" source="Axilla">-->
<!--                                            </span>-->
<!--                                        </th>-->
<!--                                        <th style="width: 7em">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.ItemPackage" source="Axilla">-->
<!--                                            </span>-->
<!--                                        </th>-->
<!--                                        <th pSortableColumn="price" style="width: 6em">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.Price" source="Axilla">-->
<!--                                            </span>-->
<!--                                            <p-sortIcon field="price"></p-sortIcon>-->
<!--                                        </th>-->
<!--                                        <th style="width: 8em;">-->
<!--                                            <span translation="Axilla.OrderGuide.Article.Count" source="Axilla">-->
<!--                                            </span>-->
<!--                                        </th>-->
<!--                                        <th style="width: 6em">-->
<!--                                            <span translation="Axilla.Actions" source="Axilla">-->
<!--                                            </span>-->
<!--                                        </th>-->
<!--                                    </tr>-->
<!--                                </ng-template>-->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 10em">
                                            <span translation="Axilla.OrderGuide.Article.Picture" source="Axilla">
                                            </span>
                                        </th>
                                        <th style="width: 10em">
                                            <span translation="Axilla.OrderGuide.Article.Code" source="Axilla">
                                            </span>
                                        </th>
                                        <th>
                                            <span translation="Axilla.OrderGuide.Article.Title" source="Axilla">
                                            </span>
                                        </th>
                                        <th>
                                            <span translation="Axilla.OrderGuide.Article.Description" source="Axilla">
                                            </span>
                                        </th>
                                        <th style="width: 5em; text-align: right">
                                            <span translation="Axilla.OrderGuide.Article.ItemAmount" source="Axilla">
                                            </span>
                                        </th>
                                        <th style="width: 7em">
                                            <span translation="Axilla.OrderGuide.Article.ItemPackage" source="Axilla">
                                            </span>
                                        </th>
                                        <th style="width: 6em">
                                            <span translation="Axilla.OrderGuide.Article.Price" source="Axilla">
                                            </span>
                                        </th>
                                        <th style="width: 8em;">
                                            <span translation="Axilla.OrderGuide.Article.Count" source="Axilla">
                                            </span>
                                        </th>
                                        <th style="width: 6em">
                                            <span translation="Axilla.Actions" source="Axilla">
                                            </span>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-record="$implicit">
                                    <tr>
                                        <td>
                                            <app-image-container [articleId]="record.code"
                                                                 [height]="68"></app-image-container>
                                        </td>
                                        <td>
                                            <span class="p-column-title">{{'Axilla.OrderGuide.Article.Code' | localize}}</span>
                                            {{ record.code }}
                                        </td>
                                        <td>
                                            <span class="p-column-title">{{'Axilla.OrderGuide.Article.Title' | localize}}</span>
                                            {{ record.title }}
                                        </td>
                                        <td>
                                            <span class="p-column-title">{{'Axilla.OrderGuide.Article.Description' | localize}}</span>
                                            <div class="td-overflow">
                                                {{ record.description }}
                                            </div>
                                        </td>
                                        <td style="text-align: right">
                                            <span class="p-column-title">{{'Axilla.OrderGuide.Article.ItemAmount' | localize}}</span>
                                            {{ record.amount }}
                                        </td>
                                        <td>
                                            <span class="p-column-title">{{'Axilla.OrderGuide.Article.ItemPackage' | localize}}</span>
                                            <span *ngIf="record.amount == 1"
                                                  translation="Axilla.OrderGuide.Article.AmountPce" source="Axilla">
                                            </span>
                                            <span *ngIf="record.amount > 1"
                                                  translation="Axilla.OrderGuide.Article.AmountBox" source="Axilla">
                                            </span>
                                        </td>
                                        <td>
                                            <span class="p-column-title">{{'Axilla.OrderGuide.Article.Price' | localize}}</span>
                                            {{ record.price | currency:getCurrency(record.currency):'symbol-narrow':'.2-2' }}
                                        </td>
                                        <td style="width: 150px">
                                            <span class="p-column-title">{{'Axilla.OrderGuide.Article.Count' | localize}}</span>
                                            <p-spinner [(ngModel)]="record.quantity"
                                                       [step]="1"
                                                       [min]="0"
                                                       OnlyNumber="true"
                                                       inputStyleClass="item-quantity"
                                                       [formatInput]="true"
                                                       thousandSeparator=","
                                                       decimalSeparator="."
                                                       (onBlur)="confirmChangingItemCount(record)"></p-spinner>
                                        </td>
                                        <td>
                                            <div class="d-flex justify-content-around">
                                                <button class="btn btn-success"
                                                        (click)="remove(record)">
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>

                            <div class="primeng-no-data"
                                 *ngIf="primengTableHelper.totalRecordsCount == 0 && !primengTableHelper.isLoading && basket.length == 0">
                                <span translation="Axilla.NoData" source="Axilla"></span>
                            </div>
                            <div class="primeng-no-data" *ngIf="primengTableHelper.isLoading">
                                <span translation="Axilla.LoadingData" source="Axilla"></span>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="row" *ngIf="isBackOrderFeatureEnabled">
                    <div class="col-lg-12">
                        <ng-container *ngIf="isBackorderAvailable">
                            <div class="faq-container">
                                <h4>
                                    <span translation="Axilla.App.Webshop.Backorder" source="Axilla"></span>:
                                </h4>
                                <ng-container *ngIf="checkOnlineHelperFeature()">
                                    <helper bookmark="backorder"></helper>
                                </ng-container>
                            </div>

                            <app-backorder-basket></app-backorder-basket>
                        </ng-container>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <app-base-modal #appBaseModal
                    (onClose)="onCancelSelectTargetRole()"
                    (onYesClick)="onSelectTargetRole('Punchout')"
                    (onNoClick)="onSelectTargetRole('Webshop')"></app-base-modal>

    <div class="spinner-container" style="z-index: 5;" *ngIf="isLoading">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>


